// DEV-61. Форма запроса восстановления доступа: «Забыли пароль?» на странице входа.
//
// Ответ показывается один и тот же при любом адресе: и когда письмо ушло, и
// когда адреса в системе нет. Поэтому на экране всегда ответ сервера (он
// одинаков по построению), а сбой связи не подменяется догадкой о записи.

import React, { FC, useState } from "react";
import RecoveryService from "../../services/RecoveryService";
import ButtonComponent from "../buttons/ButtonComponent";
import { RECOVERY_REQUEST_ANSWER } from "../../utils/recovery";

const RecoveryRequestForm: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const [email, setEmail] = useState<string>("");
  const [answer, setAnswer] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const requestRecovery = async (e: React.FormEvent) => {
    e.preventDefault();

    if (submitting) return;

    setSubmitting(true);

    try {
      const data = await RecoveryService.request(email);
      setAnswer(data?.message || RECOVERY_REQUEST_ANSWER);
    } catch (error) {
      // Ответ не должен отличаться в зависимости от того, что произошло:
      // иначе форма снова становится способом проверить учётную запись.
      setAnswer(RECOVERY_REQUEST_ANSWER);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="loginForm_conteiner" data-form="recovery-request">
      <div className="loginform_title">ВОССТАНОВЛЕНИЕ ДОСТУПА</div>

      <form onSubmit={requestRecovery}>
        <div className="loginForm_form">
          <label htmlFor="recovery-email">адрес почты:</label>
          <input
            className="loginForm_input"
            id="recovery-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoCapitalize="none"
          />
        </div>

        <div className="loginForm_btns">
          <ButtonComponent title="Отправить ссылку" size="100%" />
        </div>
      </form>

      {answer ? (
        <div className="recovery_answer" role="status" data-recovery-answer>
          {answer}
        </div>
      ) : null}

      {onClose ? (
        <ButtonComponent
          onClick={onClose}
          title="вернуться ко входу"
          type="out"
          size="100%"
        />
      ) : null}
    </div>
  );
};

export default RecoveryRequestForm;
